<template>
  <div class="d-flex flex-row justify-end">
    <div class="text-caption text-grey d-flex align-end">
      <div class="me-2">{{ $t("header.language") }}</div>
      <v-select
        v-model="$i18n.locale"
        :items="languageOptions"
        item-title="title"
        item-value="id"
        density
        hide-details
        variant="outlined"
      >
        <template v-slot:selection="{ item }">
          <span class="text-caption">
            {{ item.title }}
          </span>
        </template>

        <template v-slot:item="{ item, props }">
          <v-list-item density="compact" v-bind="props">
            <template v-slot:title>
              <v-list-item-title class="text-caption">
                {{ item.title }}
              </v-list-item-title>
            </template>
          </v-list-item>
        </template>
      </v-select>
    </div>
  </div>
</template>

<script>
export default {
  name: "HeaderView",

  data() {
    return {
      languageOptions: [
        {
          title: "Indonesia",
          id: "id",
        },
        {
          title: "English",
          id: "en",
        },
      ],
    };
  },
};
</script>

<style>
</style>